// extracted by mini-css-extract-plugin
module.exports = {"text":"PaymentInfo_text__EsyFk","list":"PaymentInfo_list__GAPE5","item":"PaymentInfo_item__3Hz0p"};